export default "__VITE_ASSET__Hck6wvUi__"